import React from 'react';
import { useHasScrolled } from '@bxp-framework/components';
import { getHeaderTheme } from './themes';
import { Header } from './UiHeader.styles';
import { HeaderLogo, HeaderNav } from './components';
export default function UiHeader({ model: { content: { appearance, goToBoardsText, logInText, signUpText } } }) {
    const { backgroundColor, backgroundColorFixed, linkColor, linkColorHover } = getHeaderTheme(appearance);
    const hasScrolled = useHasScrolled(72);
    return (React.createElement(Header, { hasScrolled: hasScrolled, backgroundColor: backgroundColor, backgroundColorFixed: backgroundColorFixed, linkColor: linkColor, linkColorHover: linkColorHover },
        React.createElement(HeaderLogo, { appearance: appearance }),
        React.createElement(HeaderNav, { appearance: appearance, goToBoardsText: goToBoardsText, logInText: logInText, signUpText: signUpText })));
}
//# sourceMappingURL=UiHeader.js.map